import React from "react";
import "./Skills.css";

const Skills = () => {
  return (
    <>
      <section className="features top" id="skills">
        <div className="container">
          <section>
            <div className="heading text-center">
              <h4>My Technical Level</h4>
              <h1>Skills</h1>
            </div>

            <div class="skills-container">
              <div class="skill-card box btn_shadow">
                <h3>Frontend</h3>
                <ul>
                  <li>
                    <i class="devicon-html5-plain"></i>
                    HTML <span>Basic</span>
                  </li>
                  <li>
                    <i class="devicon-css3-plain"></i>
                    CSS <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-sass-original"></i>
                    SCSS <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-javascript-plain"></i>
                    JavaScript <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-typescript-plain"></i>
                    TypeScript <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-react-original"></i>
                    React JS <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-nextjs-plain"></i>
                    Next JS <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-redux-original"></i>
                    Redux <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-redux-original"></i>
                    Redux Toolkit <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-redux-original"></i>
                    RTK Query <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-redux-original"></i>
                    TanStack Query <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-bootstrap-plain"></i>
                    Bootstrap <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-tailwindcss-original"></i>
                    Tailwind <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-materialui-plain"></i>
                    Material UI <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-antdesign-plain"></i>
                    Ant Design <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-stylus-original"></i>
                    ShadCN <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-chartjs-plain"></i>
                    Recharts <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-chartjs-plain"></i>
                    ECharts <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-framermotion-original"></i>
                    AOS <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-framermotion-original"></i>
                    Motion <span>Advanced</span>
                  </li>
                </ul>
              </div>

              <div class="skill-card box btn_shadow">
                <h3>Backend</h3>
                <ul>
                  <li>
                    <i class="devicon-nodejs-plain-wordmark"></i>
                    Node JS <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-express-original"></i>
                    Express JS <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-azuresqldatabase-plain"></i>
                    SQL <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="fas fa-database"></i>NoSQL{" "}
                    <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-mongodb-plain"></i>
                    MongoDB <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-mongoose-original"></i>
                    Mongoose <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-postgresql-plain"></i>
                    PostgreSQL <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-mysql-original"></i>
                    MySQL <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-prisma-original"></i>
                    Prisma ORM <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-redis-plain"></i>
                    Redis <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-firebase-plain"></i>
                    Firebase <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="fas fa-cogs"></i>REST API{" "}
                    <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="fas fa-cogs"></i>JWT <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-cloudflare-plain"></i>
                    Cloudinary <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="fas fa-cogs"></i>Nodemailer{" "}
                    <span>Intermediate</span>
                  </li>
                </ul>
              </div>

              <div class="skill-card box btn_shadow">
                <h3>Tools</h3>
                <ul>
                  <li>
                    <i class="devicon-docker-plain"></i>
                    Docker <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-git-plain"></i>
                    CI/CD <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-github-original"></i>
                    GitHub <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-gitlab-plain"></i>
                    GitLab <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-vscode-plain"></i>
                    VS Code <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-chrome-plain"></i>
                    Dev Tools <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-postman-plain"></i>
                    Postman <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-hoppscotch-plain"></i>
                    Hoppscotch <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-oauth-plain"></i>
                    OAuth <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="fas fa-toolbox"></i>Bcrypt{" "}
                    <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-axios-plain"></i>
                    Axios <span>Advanced</span>
                  </li>
                  <li>
                    <i class="fas fa-laptop-code"></i>Zod <span>Advanced</span>
                  </li>
                  <li>
                    <i class="devicon-jira-plain"></i>
                    Jira <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-cypressio-plain"></i>
                    Cypress <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-clickhouse-plain"></i>
                    ClickUp <span>Intermediate</span>
                  </li>
                  {/* <li><i class="fas fa-mouse-pointer"></i>Selenium <span>Intermediate</span></li> */}
                  {/* <li><i class="fas fa-tools"></i>Jenkins <span>Intermediate</span></li> */}
                  <li>
                    <i class="devicon-netlify-plain"></i>
                    Netlify <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-vercel-original"></i>
                    Vercel <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-renpy-plain"></i>
                    Render <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-linux-plain"></i>
                    Linux <span>Intermediate</span>
                  </li>
                </ul>
              </div>

              <div class="skill-card box btn_shadow">
                <h3>Design</h3>
                <ul>
                  <li>
                    <i class="fab fa-figma"></i>Figma <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-xd-plain"></i>
                    Adobe XD <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-photoshop-plain"></i>
                    Adobe Photoshop <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-illustrator-plain"></i>
                    Adobe Illustrator <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-premierepro-plain"></i>
                    Adobe Premiere Pro <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-aftereffects-plain"></i>
                    Adobe After Effect <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="fas fa-file-alt"></i>MS Office{" "}
                    <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-sketch-plain"></i>
                    Sketch <span>Intermediate</span>
                  </li>
                  <li>
                    <i class="devicon-canva-original"></i>
                    Canva <span>Intermediate</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Skills;
